<!-- @author Shyam, @date 21-02-2025, @descriptionadded functional mapping popup component-->
<div class="mainContent" >

    <div style="height: 7vh;">
      <div>
        <label i18n="@@spmsUserReg" class="textColour" >Functional Mapping</label>
        <span class="example-spacer"></span>
      </div>
    </div>

    <div style="height: 57vh;overflow: auto;padding-left: 4%;padding-right: 4%;">
      <form novalidate [formGroup]="FormValid" style="width: 100%;">
        <div class="row" style="margin-top: 10px;"> 
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>Logic</mat-label>
              <input matInput type="text" placeholder="Logic" formControlName="logic"[(ngModel)]="functional.logic"
                required>
                <mat-error *ngIf="FormValid.controls['logic'].touched && FormValid.controls['logic'].invalid">
                    Logic is required.
                  </mat-error>
            </mat-form-field>
          </div>
        </div> 
      </form>
    </div>
    <div style="height:1vh;">
      <div class="row" style= "position:sticky;left:0;bottom:0;width:100%;">

        <div class="col-lg text-center" style="margin-top: -20px;">

          <div style="text-align: end;">

            <button i18n="@@TargetClear" type="button" 
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"[style.background-color]="backgroundColorButton"(click)="saveMethod()"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:150px;color: white;">save</button>

            <button i18n="@@TargetCancel" type="button"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" (click)="cancel()"[style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:150px;color: white;">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>

